import * as React from "react";

export const IconStatistics = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 15L0 13.3333L1.66667 11.6667L1.66667 15H0ZM3.33333 15L3.33333 10L5 8.33333L5 15H3.33333ZM6.66667 15L6.66667 8.33333L8.33333 10.0208V15H6.66667ZM10 15V10.0208L11.6667 8.35417V15H10ZM13.3333 15V6.66667L15 5L15 15H13.3333ZM0 10.6875L0 8.33333L5.83333 2.5L9.16667 5.83333L15 0V2.35417L9.16667 8.1875L5.83333 4.85417L0 10.6875Z" fill="#C34A24"/>
  </svg>
);
